import React from 'react';
import { useState, useEffect } from 'react';
import { useAuth } from "../services/auth.service";
import axios from 'axios';

export default function TemplateMessage(props) {

    const [parameters, setParameters] = useState(null);
    const [inputTemplate, setInputTemplate] = useState(null);
    const [textBody, setTextBody] = useState(null);
    const [isEditable, setIsEditable] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { user, logout, currentConfig, changeCurrentConfig, getCurrentConfig } = useAuth();

    useEffect(() => {
        setParameters(props.message.text.body.components[1].parameters);
    }, [props.message.id]);

    useEffect(() => {
        const outputElement = document.getElementById(props.message.id);
        if (props.message.text.body.editable && outputElement) {
            let templateinput = localStorage.getItem(props.message.text.body.name);
            templateinput = JSON.parse(templateinput);
            let inputcleanparameters = [];
            templateinput.parameters.forEach((param, index) => {
                inputcleanparameters.push({ type: "text", text: `variable ${index + 1}` });
            });
            let useparameters = parameters;
            if (props.message.text.body.editable)
                useparameters = inputcleanparameters;
            //set body text
            let reducedParameters = useparameters.reduce((acc, param, index) => { acc[index + 1] = param.text; return acc; }, {});
            outputElement.addEventListener('keydown', function (event) {
                const target = event.target;
                if (target.tagName === 'SPAN' && target.getAttribute('contenteditable') === 'true' && event.key === 'Enter') {
                    event.preventDefault();
                    target.blur();
                    return false;
                }
            });
            outputElement.addEventListener("input", (event) => {
                const target = event.target;
                if (target.tagName === "SPAN" && target.getAttribute('contenteditable') === 'true') {
                    const index = target.dataset.index;
                    const newValue = target.innerText;
                    // Validate input against the pattern
                    const pattern = /^[\w\s!@#$%^&*()-]+$/; // Alphanumeric, spaces, and a few special characters
                    if (!pattern.test(newValue)) {
                        // Invalid input, remove the last character
                        target.innerText = newValue.slice(0, -1);
                        return;
                    }
                    reducedParameters[index] = newValue;
                    //transform redured parameters to array

                    localStorage.setItem('variables', JSON.stringify(Object.entries(reducedParameters).map(([key, value]) => ({
                        type: "text",
                        value: value
                    }))));
                }
            });
        }
    }, [textBody]);

    useEffect(() => {
        if (!parameters && !props.message.text.body.editable) return;
        //get input template from local storage
        let templateinput = localStorage.getItem(props.message.text.body.name);
        const editable = props.message.text.body.editable ? props.message.text.body.editable : false;
        setIsEditable(editable);
        if (!templateinput || templateinput === "undefined")
            templateinput = null;
        if (JSON.parse(templateinput)) {
            try {
                templateinput = JSON.parse(templateinput);
                let inputcleanparameters = [];
                templateinput.parameters.forEach((param, index) => {
                    inputcleanparameters.push({ type: "text", text: `variable ${index + 1}` });
                });
                let useparameters = parameters;
                if (props.message.text.body.editable)
                    useparameters = inputcleanparameters;
                setInputTemplate(templateinput);
                //set body text
                let reducedParameters = useparameters.reduce((acc, param, index) => { acc[index + 1] = param.text; return acc; }, {});
                if (templateinput.body === "") {
                    setTextBody(templateinput.name + " " + props.message.text.body.components[1].parameters.map(item => item.text).join(" "));
                    return;
                }
                let translated = translate(templateinput.body, reducedParameters, editable);
                setTextBody(translated);
            } catch (error) {
                console.log(error);
            }

        } else {
            //get input template from api
            const url = process.env.REACT_APP_BACKEND_API + "/template?name=" + props.message.text.body.name;
            const config = {
                headers: {
                    'x-access-token': user.accessToken,
                    'Content-Type': 'application/json',
                }
            }
            
            axios.get(url, config)
                .then((data) => {
                    try {
                        if (!data) return;
                        let template = data.data;
                        setInputTemplate(template[0]);
                        localStorage.setItem(props.message.text.body.name, JSON.stringify(template[0]));
                        let reducedParameters = parameters.reduce((acc, param, index) => { acc[index + 1] = param.text; return acc; }, {});
                        if (template[0].body === "") {
                            setTextBody(template[0].name + " " + props.message.text.body.components[1].parameters.map(item => item.text).join(" "));
                            return;
                        }
                        let translated = translate(template[0].body, reducedParameters);
                        setTextBody(translated);
                        setHasError(false);
                        setErrorMessage('');
                    } catch (error) {
                        console.log(error);
                        handleTemplateError();
                    }
                })
                .catch((error) => {
                    console.error('Template fetch error:', error);
                    handleTemplateError();
                });
        }
    }, [parameters]);

    function handleTemplateError() {
        setHasError(true);
        setErrorMessage('Error al cargar la plantilla. Mostrando solo los parámetros.');
        
        // Show only parameter values as fallback
        if (parameters && parameters.length > 0) {
            const parameterValues = parameters.map(param => param.text).join(' ');
            setTextBody(`<div style="margin-top: 8px;">${parameterValues}</div>`);
        } else {
            setTextBody(`<div style="color: #dc2626; font-style: italic;">No se pudo cargar la plantilla</div>`);
        }
    }

    function translate(input, variables, editable) {
        // Replace placeholders with variables
        let translated = input.replace(/\{\{(\d+)\}\}/g, (match, number) => {
            if (!editable)
                return variables[number] || match;
            const variable = variables[number];
            if (variable) {
                return `<span contenteditable="true" placeholder="variable ${number}" data-index="${number}" style="white-space: nowrap;">variable ${number}</span>`;
            }
            return match;
        });

        // Replace bold and italic formatting
        translated = translated.replace(/\*(.*?)\*/g, '<b>$1</b>');
        translated = translated.replace(/_(.*?)_/g, '<i>$1</i>');

        // Combine remaining formatting
        translated = translated.replace(/(<i>.*)(<b>.*<\/b>.*<\/i>)/g, '$2$1');

        return translated;
    }


    return (
        textBody ?
            <>
                {/* Template Name Header */}
                <div style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9edef',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    marginBottom: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                }}>
                    <span style={{
                        fontSize: '12px',
                        color: '#667781',
                        fontWeight: 500
                    }}>
                        📋
                    </span>
                    <span style={{
                        fontSize: '13px',
                        color: '#008069',
                        fontWeight: 600,
                        fontFamily: 'Inter, Roboto, Arial, sans-serif'
                    }}>
                        {props.message.text.body.name}
                    </span>
                </div>
                
                <div id={props.message.id} dangerouslySetInnerHTML={{ __html: textBody }}></div>
                {hasError && (
                    <div className="text-xs text-red-500 mt-2 px-3 py-2 bg-red-50 border border-red-200 rounded-md">
                        {errorMessage}
                    </div>
                )}
                {isEditable && !hasError ?
                    <div className="text-xs text-gray-500 mt-4">
                        <button
                            onClick={props.sendTemplateMessage}
                            className='text-xs text-gray-500 hover:text-gray-700'
                        >
                            Enviar
                        </button>
                        <button
                            onClick={props.cancelTemplateMessage}
                            className='text-xs ml-4 text-gray-500 hover:text-gray-700'
                        >
                            Cancelar
                        </button>
                    </div> : <></>}
            </> :
            <div></div>
    )
}